import { Iso900114001ConfirmDialog } from "../../../components/shared/Iso900114001ConfirmDialog";

type Props = {
  open: boolean;
  numero: number | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export function CalidadConfirmDeleteModal({
  open,
  numero,
  deleting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Iso900114001ConfirmDialog
      open={open && numero !== null}
      title="Eliminar incidencia"
      description={numero !== null
        ? `¿Seguro que quieres eliminar la incidencia Nº ${numero}? Esta acción no se puede deshacer.`
        : ""}
      confirming={deleting}
      onClose={onClose}
      onConfirm={() => {
        void onConfirm();
      }}
    />
  );
}
